import Swal from "sweetalert2";

/** Bulk delete quotes with a SweetAlert2 dialog.
 * @param {Array} quoteIds - The list of quotes to delete.
 * @param {function} callback - The callback function to execute after deletion.
 */
export async function bulkDeleteQuotes(payload, callback) {
    let { value } = await Swal.fire({
        title: "Delete Quotes",
        html:
            "Are you sure you want to <strong>Delete</strong> the selected Quotes?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(payload);
    }
}

/** Delete a quote with a SweetAlert2 dialog.
 * @param {string} quoteId - The ID of the quote to delete.
 * @param {function} callback - The callback function to execute after deletion.
 */
export async function deleteQuote(quoteId, callback) {
    let { value } = await Swal.fire({
        title: "Delete Quote",
        html:
            "Are you sure you want to <strong>Delete</strong> this Quote?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(quoteId);
    }
}


/** Cancel a quote with a SweetAlert2 dialog.
 * @param {string} quoteId - The ID of the quote to cancel.
 * @param {function} callback - The callback function to execute after cancellation.
 */
export async function cancelQuote(quoteId, callback) {
    const { value } = await Swal.fire({
        title: "Cancel Quote",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        html: "Are you sure you want to <strong>Cancel</strong> this Quote?",
        focusConfirm: false,
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        allowOutsideClick: false,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(quoteId);
    }
}


/** Duplicate a quote with a SweetAlert2 dialog.
 * @param {*} quoteId - The ID of the quote to duplicate.
 * @param {*} callback - The callback function to execute after duplication.
 */
export async function duplicateQuote(quoteId, callback) {
    let { value } = await Swal.fire({
        title: "Duplicate Quote",
        html:
            "Are you sure you want to <strong>duplicate</strong> this Quote?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(quoteId, true);
    }
}

/** Download a quote as a PDF with a SweetAlert2 dialog.
 * @param {*} quoteId - The ID of the quote to download.
 * @param {*} callback - The callback function to execute after downloading.
 */
export async function downloadQuotePDF(quoteId, quoteNumber, callback) {
    let { value } = await Swal.fire({
        title: "Download Quote",
        html:
            "Are you sure you want to <strong>download</strong> this Quote?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(quoteId, quoteNumber);
    }
}


/**
 * Convert a quote to a booking with a SweetAlert2 dialog.
 * @param {*} quoteId - The ID of the quote to convert.
 * @param {*} callback - The callback function to execute after confirmation.
 */
export async function convertToBooking(quoteId, callback) {
    let { value } = await Swal.fire({
        html:
            "Are you sure you want to <strong>convert</strong> this quote to a booking?",
        title: "Convert to Booking",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        showLoaderOnConfirm: true,
        timerProgressBar: true,
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(quoteId);
    }
}

/** Bulk convert quotes to bookings with a SweetAlert2 dialog.
 * @param {Array} quoteIds - The list of quotes to convert.
 * @param {function} callback - The callback function to execute after conversion.
 */
export async function bulkConvertToBooking(quoteIds, callback) {
    let { value } = await Swal.fire({
        title: "Convert to Booking",
        html: "Are you sure you want to <strong>convert</strong> these quotes to bookings?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        showLoaderOnConfirm: true,
        timerProgressBar: true,
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(quoteIds);
    }
}

/** Export quotes with a SweetAlert2 dialog.
 * @param {Array} payload - The data to export.
 * @param {function} callback - The callback function to execute after exporting.
 */
export async function exportQuotes(payload, callback) {
    let { value } = await Swal.fire({
        title: "Export Quotes",
        html: "Are you sure you want to <strong>export</strong> these quotes?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        showLoaderOnConfirm: true,
        timerProgressBar: true,
        onClose: () => {
            setTimeout(() => { }, 1500);
        }
    });
    if (value) {
        await callback(payload);
    }
}